import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import ImportProductStep1 from './ImportProductStep1';
import ImportProductStep2 from './ImportProductStep2';
import ImportProductStep3 from './ImportProductStep3';
import classes from './ImportProduct.module.scss';

const renderButton = (subType, title, onClick, disabled = false) => (
  <div className={classes.buttons}>
    <Button
      subType={subType}
      title={title}
      onClick={onClick}
      className={classes.button}
      disabled={disabled}
    />
  </div>
);

const ImportProduct = (props) => {
  const {
    title,
    processing,
    completed,
    products = [],
    showProgress,
    createdProducts,
    failedProducts,
    csvfile,
    cancelProcess,
    createProducts,
    handleChange,
    processCSV,
    showErrorPanel,
    toggleErrorPanel,
  } = props;

  if (processing && !completed && !showProgress) {
    return (
      <ImportProductStep2
        createProducts={createProducts}
        cancelProcess={cancelProcess}
        renderButton={renderButton}
        productsToCreate={products.length}
      />
    );
  }

  if (showProgress) {
    return (
      <ImportProductStep3
        products={products}
        failedProducts={failedProducts}
        createdProducts={createdProducts}
        cancelProcess={cancelProcess}
        completed={completed}
        renderButton={renderButton}
        showErrorPanel={showErrorPanel}
        toggleErrorPanel={toggleErrorPanel}
      />
    );
  }

  return (
    <ImportProductStep1
      title={title}
      processing={processing}
      handleChange={handleChange}
      processCSV={processCSV}
      csvfile={csvfile}
      renderButton={renderButton}
    />
  );
};

ImportProduct.propTypes = {
  title: PropTypes.string,
  processing: PropTypes.bool,
  completed: PropTypes.bool,
  products: PropTypes.array,
  showProgress: PropTypes.bool,
  createdProducts: PropTypes.number,
  failedProducts: PropTypes.number,
  csvfile: PropTypes.object,
  cancelProcess: PropTypes.func,
  createProducts: PropTypes.func,
  handleChange: PropTypes.func,
  processCSV: PropTypes.func,
  showErrorPanel: PropTypes.bool,
  toggleErrorPanel: PropTypes.func,
};

export default ImportProduct;
